export const formatDate = (value, delimiter = '/') => {
    const dateObj = new Date(value);
    const date = dateObj.getDate();
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();
    const monthNormalized = month <= 9 ? `0${month}` : month;

    return `${date}${delimiter}${monthNormalized}${delimiter}${year}`;
};
